import JobAlertsContextualSuccessBg from "./SuccessBg";
import styles from "./Success.module.scss";

const JobAlertsContextualSuccess = () => (
    <div className={styles.wrapper}>
        <JobAlertsContextualSuccessBg />
        <div className={styles.innerContainer}>
            <img
                alt=""
                className={styles.featureImg}
                height="592"
                role="presentation"
                src="https://cms-assets.themuse.com/media/jobalerts_success.png"
                width="512"
            />
            <div className={styles.content}>
                <h3 className={styles.heading}>You are all set!</h3>
                <p className={styles.message}>
                    You&rsquo;ll be receiving weekly job
                    <br />
                    recommendations
                    <br />
                    every week.
                </p>
            </div>
        </div>
    </div>
);

JobAlertsContextualSuccess.displayName = "JobAlertsContextualSuccess";

export { JobAlertsContextualSuccess as default };
